import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';
import { getPdpTooltipDismissed, pdpCoachmarkMaxViewsExceeded } from './helpers';
import {
    getPdpTooltipDismissed as onboardingTooltipDismissed,
    pdpCoachmarkMaxViewsExceeded as onboardingMaxViewsExceeded,
} from '../PdpRespTradeOnboardingCoachmark/helpers';
import {
    isOnboardingDesignManagerCoachmarkExpired,
    canSkipDesignManagerOnboardingCoachmark,
} from '../PdpRespTradeDesignManagerOnboardingCoachmark/fetchTradeDesignManagerOnboarding';
import { fetchTradeOnboardingEligibility } from '../../global/tradeOnboarding/fetchTradeOnboardingEligibility';
import { TRADE_ONBOARDING_TYPE_PDP } from '../../global/tradeOnboarding/constants';

const query = graphql`
    query fetchTradeOnApprovalEligibilityQuery($userId: String!, $itemId: String!) {
        viewer {
            item(itemId: $itemId) {
                displayInfo(buyerId: $userId) {
                    ctas {
                        showRequestOnApproval
                    }
                }
            }
        }
    }
`;

export const fetchTradeOnApprovalEligibility = (() => {
    // Cached query promise
    let queryResult = null;

    return function(relayEnvironment, userId, itemId) {
        // Already cached? Return it!
        if (queryResult) {
            return queryResult;
        }

        return fetchTradeOnboardingEligibility(
            relayEnvironment,
            userId,
            TRADE_ONBOARDING_TYPE_PDP
        ).then(userEligibleForOboarding => {
            if (
                /**
                 * On approval tooltip depends on onboarding.
                 * It should not show if user is eligible for onboarding and
                 * onboarding max views has not exceeded and was not dismissed
                 **/
                (userEligibleForOboarding &&
                    !onboardingMaxViewsExceeded() &&
                    !onboardingTooltipDismissed()) ||
                pdpCoachmarkMaxViewsExceeded() ||
                getPdpTooltipDismissed()
            ) {
                // Cache query promise
                queryResult = Promise.resolve(false);
                return queryResult;
            }

            canSkipDesignManagerOnboardingCoachmark({ relayEnvironment, userId }).then(
                skipDMExperience => {
                    if (!skipDMExperience && !isOnboardingDesignManagerCoachmarkExpired()) {
                        queryResult = Promise.resolve(false);
                        return queryResult;
                    }
                }
            );

            queryResult = fetchQuery(relayEnvironment, query, {
                userId,
                itemId,
            }).then(response =>
                get(response, 'viewer.item.displayInfo.ctas.showRequestOnApproval')
            );

            return queryResult;
        });
    };
})();
